"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatButton = require("./ChatButton");
Object.keys(_ChatButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatButton[key];
    }
  });
});